import React from 'react';
import PropTypes from 'prop-types';
import { cc } from '../../modules/styles';
import './MenuItem.css';

/**
 * Menu Item
 */

const MenuItem = ({ name, onClick, selected }) => {
  return (
    <button
      className={cc('MenuItem', selected ? 'MenuItem--selected' : '')}
      data-name={name}
      onClick={_ => {
        onClick(name);
      }}
    >
      {name}
    </button>
  );
};

MenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};

export default MenuItem;
